import { render, staticRenderFns } from "./PersonalPage.vue?vue&type=template&id=692765c4&scoped=true&"
import script from "./PersonalPage.vue?vue&type=script&lang=js&"
export * from "./PersonalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692765c4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/PersonalPage.vue
// module id = 213
// module chunks = 3